import type { AuthData } from '@/hooks/use-auth';
import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import "@/index.css";

type RouterContext = {
  auth: AuthData;
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <Outlet />
  )
}
